import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  html, body {
    margin: 0;
    box-sizing: border-box;
  }


  body {
    margin: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
    color: #333;
  }

  @font-face {
    font-family: "MySatisfy";
    src: url("/Satisfy-Regular.ttf") format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  
  .my-satisfy-font {
    font-family: "MySatisfy", sans-serif;
  }
`;

/*

  html, body, #root {
    height: 100%;
  }

*/